<template>
  <form @submit.prevent="validate">
    <div class="text-end">
      <help
        helpId="step1_help"
        title="Vendégház választás"
        text="Apartman esetén csak péntektől péntekig tud foglalni míg vendégház esetén minimum 3 éjszakára"
      ></help>
    </div>
    <div class="row mb-2" v-if="user && user.role_id != 10">
      <div class="col-md-4 mx-auto text-center">
        <Loading mini v-if="!guests"></Loading>
        <div v-else>
          <h5 class="mb-3">Válasszon felhasználót:</h5>
          <v-select
            v-model="model.user_id"
            :options="guests"
            :reduce="(option) => option.id"
            label="name"
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                :required="!model.user_id"
                v-bind="attributes"
                v-on="events"
                :placeholder="!model.user_id ? 'Válassz felhasználót!' : ''"
              />
            </template>
            <template #option="{ name, email }">
              {{ name }} ({{ email }})
            </template>
          </v-select>
        </div>
      </div>
    </div>
    <Loading v-if="!guesthouses" title="Vendégházak betöltése"></Loading>
    <!--<div class="accordion" v-else>
			<h5 class="text-center mt-2 mb-3">Válasszon vendégházat:</h5>
			<div class="row row-cols-1 ros-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4">
				<div class="col" v-for="(guesthouse,id) in guesthouses" :key="id">
					<input type="radio" class="d-none" v-model="guesthouse_id" :value="guesthouse.id" :id="'guesthouse_'+guesthouse.id+'_checkbox'">
					<label :for="'guesthouse_'+guesthouse.id+'_checkbox'" class="d-block">
						<div class="card h-100" :class="{'bg-info': guesthouse_id == guesthouse.id}">
							<img :src="guesthouse.media[0].original_url" class="card-img-top img-responsive" alt="..." style="height:200px; object-fit: cover;">
							<div class="card-body">
								<h5 class="card-title">
									{{guesthouse.name}}
									<button type="button" class="btn btn-icon btn-blue float-end" v-b-toggle="'collapse'+id"><i class="fa fa-info"></i></button>
								</h5>
								<b-collapse :id="'collapse'+id" class="mt-2" accordion="guesthouse-accordion">
									<p style="max-height:200px; overflow:auto;">{{guesthouse.description}}</p>
								</b-collapse>
							</div>
						</div>
					</label>
				</div>
			</div>
		</div>-->
    <Loading v-if="!settings"></Loading>
    <div class="row mt-2" v-else>
      <div class="col-md-4 mx-auto text-center">
        <h5 class="mb-3">Válasszon időpontot:</h5>
        <div class="input-group">
          <!-- -->
          <VueHotelDatepicker
            class="form-control p-0"
            v-if="renderComponent"
            :minNight="minNight"
            :maxNight="maxNight"
            format="YYYY-MM-DD"
            :disabledDates="disabled_dates"
            @confirm="selectperiod"
            placeholder="Válasszon dátumot"
            separator="-"
            :weekList="['Vas', 'Hé', 'Ke', 'Sze', 'Csü', 'Pé', 'Szo']"
            :monthList="[
              'Január',
              'Február',
              'Március',
              'Április',
              'Május',
              'Június',
              'Július',
              'Augusztus',
              'Szeptember',
              'Október',
              'November',
              'December',
            ]"
            fromText="Érkezés"
            toText="Távozás"
            resetText="visszaállít"
            confirmText="Jóváhagy"
            :maxDate="maxDate"
            :minDate="minDate"
          />
          <span class="input-group-text"><i class="fa fa-calendar"></i></span>
        </div>
      </div>
    </div>
    <div class="row mt-2" v-if="booking_data">
      <div class="col-md-12 mx-auto">
        <h6 class="text-center">Foglalások a választott időszakban</h6>
        <h6 class="mb-3 text-center">
          <span>
            <i class="fa fa-circle text-red"></i>
            foglalt
          </span>
          <span>
            <i class="fa fa-circle text-lime"></i>
            szabad
          </span>
        </h6>
        <h5 class="my-3 text-center">
          <i class="fa fa-info-circle"></i> Balatonfüredre csak
          péntektől-péntekig tartó intervallumra lehet foglalni. Amennyiben
          ettől eltérő időszakot választ, a vendégház nem jelenik meg a
          találatok között.
        </h5>
        <h5 class="my-3 text-center">
          <i class="fa fa-info-circle"></i> A vendégházat, a képére kattintva
          tudja kiválasztani.
        </h5>
        <div
          class="mt-3 row"
          v-for="(guesthouse, id) in booking_data"
          :key="id"
        >
          <div class="col-md-3">
            <input
              type="radio"
              class="d-none"
              v-model="guesthouse_id"
              :value="guesthouse.id"
              :id="'guesthouse_' + guesthouse.id + '_checkbox'"
            />
            <label
              :for="'guesthouse_' + guesthouse.id + '_checkbox'"
              class="d-block"
            >
              <div
                class="card h-100"
                :class="{ 'bg-info': guesthouse_id == guesthouse.id }"
              >
                <img
                  :src="
                    guesthouses.find((g) => g.id == guesthouse.id).media[0]
                      .original_url
                  "
                  class="card-img-top img-responsive"
                  alt="..."
                  style="height: 200px; object-fit: cover"
                />
                <div class="card-body">
                  <h5 class="card-title">
                    {{ guesthouses.find((g) => g.id == guesthouse.id).name }}
                    <button
                      type="button"
                      class="btn btn-icon btn-blue float-end"
                      v-b-toggle="'collapse' + id"
                    >
                      <i class="fa fa-info"></i>
                    </button>
                  </h5>
                  <b-collapse
                    :id="'collapse' + id"
                    class="mt-2"
                    accordion="guesthouse-accordion"
                  >
                    <p
                      style="max-height: 200px; overflow: auto"
                      v-html="
                        guesthouses.find((g) => g.id == guesthouse.id)
                          .description
                      "
                    ></p>
                  </b-collapse>
                </div>
              </div>
            </label>
          </div>
          <div class="col-md-9">
            <div class="table-responsive">
              <table class="table table-bordered table-hover table-small-font">
                <thead>
                  <tr>
                    <th></th>
                    <th
                      v-for="(date, d_id) in Object.keys(
                        guesthouse.data[Object.keys(guesthouse.data)[0]]
                      )"
                      :key="d_id"
                    >
                      {{ date | moment("MM.DD") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(room, r_id) in guesthouse.data" :key="r_id">
                    <th>{{ r_id }}</th>
                    <td
                      v-for="(date, did) in room"
                      :key="did"
                      :class="{ 'bg-red': date, 'bg-lime': !date }"
                    ></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <hr class="mt-4" v-if="id < booking_data.length - 1" />
        </div>
      </div>
    </div>
    <button class="d-none" type="submit" ref="submitter"></button>
  </form>
</template>

<script>
/*<b-carousel>
								<b-carousel-slide v-for="(media,id) in guesthouse.media" :key="id" :img-src="media.original_url"></b-carousel-slide>
							</b-carousel>*/
import Guesthouse from "../../apis/Guesthouse";
import Confirmation from "../../apis/Confirmation";
import Setting from "../../apis/Setting";
import User from "../../apis/User";
import moment from "moment";
import VueHotelDatepicker from "@northwalker/vue-hotel-datepicker";
import Booking from "../../apis/Booking";
export default {
  components: {
    VueHotelDatepicker,
  },
  data() {
    return {
      guests: null,
      settings: null,
      renderComponent: true,
      guesthouse_id: null,
      disabled_dates: [],
      model: {
        arrive_at: null,
        leave_at: null,
      },
      guesthouses: false,
      booking_data: false,
    };
  },
  created() {
    Setting.index()
      .then((response) => {
        this.settings = response.data;
      })
      .catch(() => {
        this.settings = [];
      });
    Guesthouse.index().then((response) => {
      this.guesthouses = response.data;
    });
    User.wizardGuests().then((response) => {
      this.guests = response.data;
    });
  },
  computed: {
    maxDate() {
      if (this.settings && this.user && this.user.role_id != 1) {
        return this.settings.find((s) => s.label == "booking_open_until").value;
      } else {
        return false;
      }
    },
    minDate() {
      if (this.user && this.user.role_id == 1) {
        return moment()
          .subtract(1, "years")
          .subtract(1, "days")
          .format("YYYY-MM-DD");
      } else {
        return moment().subtract(1, "days").format("YYYY-MM-DD");
      }
    },
    minNight() {
      if (this.user && this.user.role_id == 1) {
        return 0;
      }
      if (this.settings) {
        return this.settings.find((s) => s.label == "min_night").value;
      }
      return 3;
    },
    maxNight() {
      if (this.user && this.user.role_id == 1) {
        return 0;
      } else {
        return 14;
      }
    },
    user() {
      return this.$store.state.user;
    },
    selected_rooms() {
      return this.$store.state.selected_rooms;
    },
  },
  watch: {
    guesthouse_id(val) {
      if (this.user.role_id == 10) {
        /* if(this.guesthouses && this.guesthouses.find(g => g.id == val) && this.guesthouses.find(g => g.id == val).apartment == 1){
					this.$set(this.model,'arrive_at', null);
					this.$set(this.model,'leave_at', null);
					this.forceRerender();
				} */
        if (
          this.guesthouses &&
          this.guesthouses.find((g) => g.id == val) &&
          this.guesthouses.find((g) => g.id == val).apartment == 1
        ) {
          let start = moment();
          let end = moment(
            this.settings.find((s) => s.label == "booking_open_until").value
          );

          let tmp = start.clone().subtract(1, "days");
          if (tmp.isAfter(start, "d") && tmp.weekday() == 5) {
            console.log(tmp, tmp.weekday());
            this.disabled_dates.push(tmp.format("YYYY-MM-DD"));
          }
          while (tmp.isBefore(end)) {
            tmp.add(1, "days");
            if (tmp.weekday() != 5) {
              this.disabled_dates.push(tmp.format("YYYY-MM-DD"));
            }
          }
        } else {
          if (val && this.model.arrive_at != null) {
            this.getBookings();
            console.log("guesthouse watcher");
          }
          this.disabled_dates = [];
        }
      }
    },
    model: {
      handler(val) {
        if (val.arrive_at != null /*&& this.guesthouse_id*/) {
          this.getBookings();
          console.log("model watcher");
        }
        if (val.arrive_at == null) {
          this.booking_data = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    getBookings() {
      /*Booking.actualFront({
				arrive_at:this.model.arrive_at,
				leave_at:this.model.leave_at,
				guesthouse_id:this.guesthouse_id
			}).then(response => {
				this.booking_data = response.data;
			})*/
      Booking.actualFrontAll({
        arrive_at: this.model.arrive_at,
        leave_at: this.model.leave_at,
      }).then((response) => {
        this.booking_data = response.data;
      });
    },
    selectperiod(event) {
      this.$set(this.model, "arrive_at", event.start);
      this.$set(this.model, "leave_at", event.end);
    },
    validate() {
      if (!this.guesthouse_id) {
        Confirmation.swalErrorMessage("Válassz vendégházat!");
      } else if (!this.model.arrive_at || !this.model.leave_at) {
        Confirmation.swalErrorMessage("Válassz időpontot!");
      } else {
        this.$emit("validated", this.model);
        this.$store.commit(
          "updateSelectedGuesthouse",
          this.guesthouses.find((g) => g.id == this.guesthouse_id)
        );
        this.$store.commit("updateArriveAt", this.model.arrive_at);
        this.$store.commit("updateLeaveAt", this.model.leave_at);
        if (this.model.user_id) {
          User.show(this.model.user_id).then((response) => {
            this.$store.commit("updateWizardUser", response.data);
          });
        } else {
          this.$store.commit("updateWizardUser", this.user);
        }
        //meg kell vizsgálni, hogy van-e kiválasztva user
        //ha nincs, akkor vendég van belépve, nála belépéskopr lekérdeztük a tagsági státuszát, ezért nem kell plusz request
        //ha ki van választva user, akkor admin adja le a foglalást, ezért itt kell egy köztes lépés: lekérdezed az adott user-t id
        //alapján és a választ írod bele a vuexbe
        /*
				if(van kiválasztva user){
					kérés a szerverre ahol majd a backend lekérdezi a tagsági állapotot
					válasz mentése a vuexbe
				}
				*/
      }
    },
    submitForm() {
      this.$refs.submitter.click();
    },
    restart() {
      this.guesthouse_id = null;
      this.model = {
        arrive_at: null,
        leave_at: null,
      };
      this.forceRerender();
    },
    forceRerender() {
      this.renderComponent = false;
      this.$nextTick().then(() => {
        this.renderComponent = true;
      });
    },
  },
};
</script>
